import React from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
} from "@material-ui/core";
import { MODE_OF_PAYMENT } from "@utils/constants";

const SelectPaymentMode = ({
  classes,
  state,
  handleChange,
  bankError,
  accountError,
}) => {
  return (
    <>
      <FormControl className={classes.formControl}>
        <InputLabel htmlFor="filled-age-native-simple">
          Select Mode Of Payment
        </InputLabel>
        <Select
          required
          fullWidth
          value={state.mode_of_payment}
          onChange={handleChange}
          inputProps={{
            name: "mode_of_payment",
            id: "filled-age-native-simple",
          }}
        >
          {MODE_OF_PAYMENT.map((mode, index) => (
            <MenuItem key={index} value={mode}>
              {mode}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {state.mode_of_payment === "Bank Transfer" && (
        <>
          <div className={classes.paper} style={{ paddingLeft: "0px" }}>
            <TextField
              id="bank_name"
              name="bank_name"
              label="Bank Name"
              fullWidth
              type="text"
              className={classes.textField}
              error={bankError}
              value={state.bank_name}
              onChange={handleChange}
              margin="normal"
            />
            <TextField
              id="account_No"
              name="account_No"
              label="Account Number"
              fullWidth
              type="text"
              className={classes.textField}
              error={accountError}
              value={state.account_No}
              onChange={handleChange}
              margin="normal"
            />
          </div>
        </>
      )}
    </>
  );
};

export default SelectPaymentMode;
